import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/logo.png';
const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  class: "login-bg-wrap"
};
const _hoisted_3 = {
  class: "login-bg-card"
};
const _hoisted_4 = {
  class: "login-bg-card-item-icon"
};
const _hoisted_5 = {
  class: "login-bg-card-item-title"
};
const _hoisted_6 = {
  class: "login-bg-card-item-title-text"
};
const _hoisted_7 = {
  class: "login-bg-card-item-title-desc"
};
const _hoisted_8 = {
  class: "login-form-wrap flex-column-box"
};
const _hoisted_9 = {
  class: "login-form-wrap-header"
};
const _hoisted_10 = {
  key: 0,
  class: "login-form-wrap-header-item login-register-wrap"
};
const _hoisted_11 = {
  key: 1,
  class: "login-form-wrap-header-item login-wechat-wrap"
};
const _hoisted_12 = {
  class: "login-form-wrap-header-item-desc"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  class: "form-wrap"
};
const _hoisted_16 = {
  class: "form-wrap"
};
const _hoisted_17 = {
  key: 1,
  class: "code-wrap"
};
const _hoisted_18 = {
  class: "image-slot"
};
const _hoisted_19 = {
  class: "login-check-warp"
};
const _hoisted_20 = {
  class: "login-check-box"
};
const _hoisted_21 = {
  class: "login-form-wrap-agree"
};
import { ElMessage, ElMessageBox } from 'element-plus';
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'

import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { accountLogin, getLoginUserInfo, getWxMpQrCode, getWxAuthInfo } from '@/request/index';
import md5 from 'js-md5';
import { setToken } from '@/api';
import { useUserStore } from '@/pinia/userStore';
import RestPwd from '@/components/user/restPwd.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {
    const userStore = useUserStore();
    const route = useRoute();
    const router = useRouter();
    const phonePrifix = ref('+86');
    const phoneNumber = ref('');
    const agree = ref(false);
    const freeLogin = ref(true);
    const password = ref();
    const username = ref();
    const cardList = ref([{
      title: '海量数字人',
      desc: '免费试用多种形象',
      icon: 'ri-user-line',
      iconActive: 'ri-user-fill'
    }, {
      title: '数字人直播',
      desc: '开启实时互动直播',
      icon: 'ri-video-on-ai-line',
      iconActive: 'ri-video-on-ai-fill'
    }, {
      title: '声音克隆',
      desc: '定制专属音色',
      icon: 'ri-image-ai-line',
      iconActive: 'ri-image-ai-fill'
    }, {
      title: '形象克隆',
      desc: '采集训练克隆数字人',
      icon: 'ri-speak-ai-line',
      iconActive: 'ri-speak-ai-fill'
    }, {
      title: '应用商店',
      desc: '多种应用场景',
      icon: 'ri-color-filter-ai-line',
      iconActive: 'ri-color-filter-ai-fill'
    }]);
    const prifixOptions = [{
      label: '+86',
      value: '+86'
    }];
    const login = () => {
      // router.push('/');
      if (!username.value) return ElMessage.error('请输入用户名');
      if (!password.value) return ElMessage.error('请输入密码');
      accountLogin({
        username: username.value,
        password: md5(password.value)
      }).then(res => {
        const {
          code,
          data,
          msg
        } = res.data;
        if (code === 200) {
          setToken(data.token);
          getUserInfo();
        } else if (code === 5104) {
          password.value = '';
          ElMessageBox.confirm('您的密码错误,是否需要修改密码?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            openResetPwdDialog(username.value);
          }).catch(() => {
            // 用户取消则不做处理
          });
        }
      });
    };
    const getUserInfo = () => {
      getLoginUserInfo().then(res => {
        const {
          code,
          data,
          msg
        } = res.data;
        if (code == 200) {
          userStore.setUserInfo(data);
          ElMessage.success('登录成功！');
          // 获取用户资源信息
          // resourceStore.fetchUserResourceInfo();
          router.push('/');
        } else {
          setToken('');
        }
      }).catch(res => {
        setToken('');
      });
    };
    // 微信注册
    const register = ref(false);
    const codeLoading = ref(false);
    const qrCode = ref('');
    const sceneStr = ref('');
    const getCodeTime = ref(0);
    const wxRegister = () => {
      if (!agree.value) return ElMessage.warning('请先阅读服务协议与隐私政策');
      register.value = true;
      codeLoading.value = true;
      getQrCode();
    };
    const getQrCode = () => {
      var _route$query;
      let data = {};
      if (route && route !== null && route !== void 0 && (_route$query = route.query) !== null && _route$query !== void 0 && _route$query.inviteCode) {
        var _route$query2;
        data = {
          inviteCode: (_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.inviteCode
        };
      }
      getWxMpQrCode(data).then(res => {
        const {
          data
        } = res.data;
        qrCode.value = (data === null || data === void 0 ? void 0 : data.qrCode) || '';
        sceneStr.value = data.sceneStr || '';
        getCodeTime.value = new Date().getTime();
        getWxInfo();
      }).finally(() => {
        showCodeTip.value = false;
        codeLoading.value = false;
      });
    };
    const wxinfoTimer = ref();
    const showCodeTip = ref(false);
    const getWxInfo = () => {
      if (new Date().getTime() - getCodeTime.value > 1000 * 60 * 5) {
        clearTimeout(wxinfoTimer.value);
        showCodeTip.value = true;
        return;
      }
      getWxAuthInfo(sceneStr.value).then(res => {
        const {
          code,
          data,
          success
        } = res.data;
        if (success) {
          clearTimeout(wxinfoTimer.value);
          setToken(data.token);
          getUserInfo();
          return;
        }
        wxinfoTimer.value = setTimeout(() => {
          getWxInfo();
        }, 2000);
      });
    };
    const toggleRegister = () => {
      clearTimeout(wxinfoTimer.value);
      register.value = false;
    };
    const resetPwdDialogRef = ref();
    const openResetPwdDialog = username => {
      resetPwdDialogRef.value.openDialog(username);
    };
    onMounted(() => {
      const token = localStorage.getItem('token');
      if (token) router.push('/');
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_Refresh = _resolveComponent("Refresh");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_icon_picture = _resolveComponent("icon-picture");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_router_link = _resolveComponent("router-link");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_cache[15] || (_cache[15] = _createElementVNode("div", {
        class: "login-logo"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "logo"
      }), _createElementVNode("div", {
        class: "login-logo-text-title"
      }, "万川智媒")], -1)), _createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createStaticVNode("<div class=\"login-bg-title\" data-v-23aec841><span class=\"login-bg-title-text\" data-v-23aec841>您即将进入</span><span class=\"login-bg-title-text highlight\" data-v-23aec841>万川智媒</span><div class=\"login-bg-title-text\" data-v-23aec841>AI自媒体平台</div></div><div class=\"login-bg-desc\" data-v-23aec841><div class=\"login-bg-desc-text\" data-v-23aec841><div class=\"login-bg-desc-text-item\" data-v-23aec841>万川智媒是灵泽万川旗下AI系媒体平台，致力于为媒体行业提供智能化解决方案，</div><div class=\"login-bg-desc-text-item\" data-v-23aec841>帮助媒体机构提升内容创作效率和质量。</div></div></div>", 2)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "login-bg-card-item",
          key: item.title
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("i", {
          class: _normalizeClass(item.icon)
        }, null, 2)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(item.desc), 1)])]);
      }), 128))])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [!register.value ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[4] || (_cache[4] = [_createElementVNode("div", null, "请使用", -1), _createElementVNode("div", {
        class: "login-form-wrap-header-item-title"
      }, "平台账号", -1), _createElementVNode("div", null, "登录", -1)]))) : (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[5] || (_cache[5] = [_createElementVNode("div", null, "请使用", -1), _createElementVNode("i", {
        class: "ri-wechat-fill"
      }, null, -1), _createElementVNode("div", {
        class: "login-form-wrap-header-item-title"
      }, "微信", -1), _createElementVNode("div", null, "扫码登录", -1)]))), _createElementVNode("div", _hoisted_12, [!register.value ? (_openBlock(), _createElementBlock("span", _hoisted_13, "使用平台账号输入进行登录")) : (_openBlock(), _createElementBlock("span", _hoisted_14, "打开微信APP - 点击右上角“+”图标 - 点击扫码"))])]), !register.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_15, [_createElementVNode("i", {
        class: "ri-user-line",
        style: _normalizeStyle([{
          color: username.value && username.value.length >= 3 ? '#00b6b0' : '#d9d9d9'
        }, {
          "margin-right": "10px",
          "font-size": "20px"
        }])
      }, null, 4), _createVNode(_component_el_input, {
        class: "login-form-wrap-input",
        modelValue: username.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => username.value = $event),
        placeholder: "请输入您的用户名",
        clearable: ""
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("i", {
        class: "ri-lock-line",
        style: _normalizeStyle([{
          color: password.value && password.value.length >= 6 ? '#00b6b0' : '#d9d9d9'
        }, {
          "margin-right": "10px",
          "font-size": "20px"
        }])
      }, null, 4), _createVNode(_component_el_input, {
        class: "login-form-wrap-input",
        modelValue: password.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => password.value = $event),
        placeholder: "请输入密码",
        clearable: "",
        type: "password",
        onKeyup: _withKeys(login, ["enter"])
      }, null, 8, ["modelValue"])]), _createVNode(_component_el_button, {
        class: "login-form-wrap-btn",
        type: "primary",
        size: "large",
        disabled: !agree.value,
        onClick: login
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("登 录")])),
        _: 1
      }, 8, ["disabled"])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_17, [showCodeTip.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "code-tips",
        onClick: getQrCode
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Refresh)]),
        _: 1
      }), _cache[7] || (_cache[7] = _createTextVNode("二维码过期，请点击重新获取 "))])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_component_el_image, {
        class: "qr-code",
        src: qrCode.value,
        fit: "fill"
      }, {
        error: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_icon_picture)]),
          _: 1
        })])]),
        _: 1
      }, 8, ["src"])), [[_directive_loading, codeLoading.value]])])), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_divider, {
        class: "login-form-wrap-divider"
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("登录方式")])),
        _: 1
      }), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", {
        class: _normalizeClass(`login-check-box-item ${register.value ? 'active' : ''}`),
        onClick: wxRegister
      }, _cache[9] || (_cache[9] = [_createElementVNode("i", {
        class: "ri-wechat-fill"
      }, null, -1), _createElementVNode("div", {
        class: "login-check-warp-item-title"
      }, "微信登录", -1)]), 2), _createElementVNode("div", {
        class: _normalizeClass(`login-check-box-item ${!register.value ? 'active' : ''}`),
        onClick: toggleRegister
      }, _cache[10] || (_cache[10] = [_createElementVNode("i", {
        class: "ri-account-circle-fill"
      }, null, -1), _createElementVNode("div", {
        class: "login-check-warp-item-title"
      }, "账号登录", -1)]), 2)])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_checkbox, {
        modelValue: agree.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => agree.value = $event),
        class: "checkbox"
      }, null, 8, ["modelValue"]), _cache[13] || (_cache[13] = _createTextVNode("我已阅读并同意 ")), _createVNode(_component_router_link, {
        class: "login-form-wrap-agree-link",
        to: "/fwxy",
        target: "_blank"
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("《服务协议》")])),
        _: 1
      }), _cache[14] || (_cache[14] = _createTextVNode(" 与 ")), _createVNode(_component_router_link, {
        class: "login-form-wrap-agree-link",
        to: "/ysxy",
        target: "_blank"
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("《隐私政策》")])),
        _: 1
      })])])]), _createVNode(RestPwd, {
        ref_key: "resetPwdDialogRef",
        ref: resetPwdDialogRef
      }, null, 512)], 64);
    };
  }
});